<div class="perm-page">

  <!-- ── Header ─────────────────────────────────── -->
  <div class="perm-page__header">
    <div class="perm-page__title-row">
      <button type="button" class="perm-back-btn" (click)="goBack()">
        &#8592; Back
      </button>
      <div class="perm-page__title">
        <h4>Permissions</h4>
        <span class="perm-page__role-badge" *ngIf="role">
          {{ role.name }} &mdash; <code>{{ loginType }}</code>
          <span class="perm-category" [ngClass]="getCategoryClass(roleCategory)">
            {{ getCategoryName(roleCategory) | titlecase }}
          </span>
        </span>
      </div>
    </div>
  </div>

  <!-- ── Loading ────────────────────────────────── -->
  <div class="perm-loading" *ngIf="loading">
    <div class="perm-loading__spinner"></div>
    <span>Loading permission matrix…</span>
  </div>

  <!-- ── Matrix ─────────────────────────────────── -->
  <ng-container *ngIf="!loading">
<div class="perm-matrix" *ngIf="visibleGroups.length; else noModules">
  <div class="perm-table">

    <!-- Sticky column header, once for the whole table -->
    <div class="perm-row perm-row--colheader">
      <span class="perm-row__name">Name</span>
      <span class="perm-row__check">View</span>
      <span class="perm-row__check">Add</span>
      <span class="perm-row__check">Edit</span>
    </div>

    <ng-container *ngFor="let group of visibleGroups">

      <!-- Module WITH submodules: header row only, no checkboxes -->
      <div class="perm-row perm-row--module-header" *ngIf="group.rows.length">
      <span class="perm-row__name">
        {{ group.module.name }}
        <span class="perm-category" [ngClass]="getCategoryClass(group.module.category)">
          {{ getCategoryName(group.module.category) | titlecase }}
        </span>
      </span>
      </div>

      <!-- Module WITHOUT submodules: ordinary checkable row -->
      <div class="perm-row" *ngIf="!group.rows.length">
        <span class="perm-row__name">
          {{ group.module.name }}
          <span class="perm-category" [ngClass]="getCategoryClass(group.module.category)">
            {{ (group.module.category ?? 'admin') | titlecase }}
          </span>
        </span>
        <span class="perm-row__check">
          <label class="perm-checkbox" title="View">
            <input type="checkbox" [checked]="isModuleChecked(group, 'is_view')" (change)="toggleModule(group, 'is_view')" />
            <span class="perm-checkbox__mark"></span>
          </label>
        </span>
        <span class="perm-row__check">
          <label class="perm-checkbox" title="Add">
            <input type="checkbox" [checked]="isModuleChecked(group, 'is_add')" (change)="toggleModule(group, 'is_add')" />
            <span class="perm-checkbox__mark"></span>
          </label>
        </span>
        <span class="perm-row__check">
          <label class="perm-checkbox" title="Edit">
            <input type="checkbox" [checked]="isModuleChecked(group, 'is_edit')" (change)="toggleModule(group, 'is_edit')" />
            <span class="perm-checkbox__mark"></span>
          </label>
        </span>
      </div>

      <!-- Submodule rows (each may itself nest items) -->
      <ng-container *ngFor="let row of group.rows">
        <div class="perm-row perm-row--sub">
          <span class="perm-row__name">{{ row.subModule.name }}</span>
          <span class="perm-row__check">
            <label class="perm-checkbox" title="View">
              <input type="checkbox" [checked]="isChecked(row, 'is_view')" (change)="toggle(group, row, 'is_view')" />
              <span class="perm-checkbox__mark"></span>
            </label>
          </span>
          <span class="perm-row__check">
            <label class="perm-checkbox" title="Add">
              <input type="checkbox" [checked]="isChecked(row, 'is_add')" (change)="toggle(group, row, 'is_add')" />
              <span class="perm-checkbox__mark"></span>
            </label>
          </span>
          <span class="perm-row__check">
            <label class="perm-checkbox" title="Edit">
              <input type="checkbox" [checked]="isChecked(row, 'is_edit')" (change)="toggle(group, row, 'is_edit')" />
              <span class="perm-checkbox__mark"></span>
            </label>
          </span>
        </div>

        <!-- Inner module rows (type 'I'), nested one level deeper than their parent submodule -->
        <div class="perm-row perm-row--item" *ngFor="let innerModuleRow of row.innerModuleRows">
          <span class="perm-row__name">{{ innerModuleRow.innerModule.name }}</span>
          <span class="perm-row__check">
            <label class="perm-checkbox" title="View">
              <input type="checkbox" [checked]="isInnerModuleChecked(innerModuleRow, 'is_view')" (change)="toggleInnerModule(group, row, innerModuleRow, 'is_view')" />
              <span class="perm-checkbox__mark"></span>
            </label>
          </span>
          <span class="perm-row__check">
            <label class="perm-checkbox" title="Add">
              <input type="checkbox" [checked]="isInnerModuleChecked(innerModuleRow, 'is_add')" (change)="toggleInnerModule(group, row, innerModuleRow, 'is_add')" />
              <span class="perm-checkbox__mark"></span>
            </label>
          </span>
          <span class="perm-row__check">
            <label class="perm-checkbox" title="Edit">
              <input type="checkbox" [checked]="isInnerModuleChecked(innerModuleRow, 'is_edit')" (change)="toggleInnerModule(group, row, innerModuleRow, 'is_edit')" />
              <span class="perm-checkbox__mark"></span>
            </label>
          </span>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- Show More / Show Less button -->
  <div class="perm-show-more" *ngIf="hasHiddenGroups">
    <button type="button" class="perm-show-more__btn" (click)="toggleShowMore()">
      <span>{{ showMore ? '&#8593; Show Less' : '&#8595; Show More (' + hiddenGroups.length + ' advanced modules)' }}</span>
    </button>
  </div>
</div>

    <ng-template #noModules>
      <p class="perm-empty">No modules found.</p>
    </ng-template>

    <!-- ── Save ───────────────────────────────────── -->
    <div class="perm-actions" *ngIf="visibleGroups.length">
      <button type="button" class="perm-btn perm-btn--primary" [disabled]="saving" (click)="save()">
        {{ saving ? 'Saving…' : 'Save Permissions' }}
      </button>
    </div>
  </ng-container>
</div>